import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './app'
import router from './router'
import axios from 'axios'
import projectConfig from '@/config/project-config'
import utils from '@/assets/js/utils/utils';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })
 Vue.use(ElementUI);
Vue.config.productionTip = false
axios.defaults.timeout = projectConfig.timeout;
axios.defaults.baseURL = pathParameter;
window.axios = axios;
Date.prototype.format = utils.dateFormat;
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
 })
 router.afterEach(() => {
  NProgress.done()
 })
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./main.js